import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const findProcesamientos = async (filtros) => {
  try {
    const response = await mainAxios.post(
      "/v1/procesamiento-archivos/find",
      filtros,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getProcesamientoErrores = async (procesamientoId) => {
  try {
    const response = await mainAxios.get(
      `/v1/procesamiento-archivos/${procesamientoId}/errores`,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const ejecutarProcesamientoMarcacion = async (fechaBase) => {
  try {
    const response = await mainAxios.post(
      "/v1/procesamiento-archivos/procesar/marcacion",
      { fecha_base: fechaBase },
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const activarBase = async (fechasBase) => {
  try {
    const response = await mainAxios.put(
      "/v1/leads/base/activar",
      { fechas_base: fechasBase },
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const desactivarBase = async (fechasBase) => {
  try {
    const response = await mainAxios.put(
      "/v1/leads/base/desactivar",
      { fechas_base: fechasBase },
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const getLeadsFiltros = async (baseMes, cicloFinalizado = null) => {
  try {
    const body = {
      base_mes: baseMes,
      page: 1,
      size: 1
    };
    
    // Add ciclo_finalizado filter if provided
    if (cicloFinalizado !== null) {
      body.ciclo_finalizado = cicloFinalizado;
    }
    
    const response = await mainAxios.post(
      "/v1/bradescard/list/filtros",
      body,
      getDefaultHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};